import { render } from "./Fortune.vue?vue&type=template&id=7771f738&scoped=true"
import script from "./Fortune.vue?vue&type=script&lang=js"
export * from "./Fortune.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Fortune.vue?vue&type=style&index=0&id=7771f738&lang=scss&module=true"
cssModules["$style"] = style0
import "./Fortune.vue?vue&type=style&index=1&id=7771f738&lang=scss&scoped=true"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-7771f738"]])

export default __exports__